/**
 * The const values should match the constants used by the Connector service
 */
export enum ExternalSourceTypes {
  AwsEventBridge = 'AWS_EVENTBRIDGE',
  BigCommerce = 'BIGCOMMERCE',
  Klaviyo = 'KLAVIYO',
  LoopReturns = 'LOOP_RETURNS',
  Magento = 'MAGENTO',
  Ordergroove = 'ORDERGROOVE',
  Qualtrics = 'QUALTRICS',
  Recharge = 'RECHARGE',
  Shopify = 'SHOPIFY',
  Smile = 'SMILE',
  Segment = 'SEGMENT',
  Yotpo = 'YOTPO',
  Zaius = 'ZAIUS',

  Custom = 'CUSTOM',
}

export enum AutoLinkFields {
  Email = 'emails',
  Phone = 'phones.mobile',
}

export type ExternalSourceType =
  | typeof ExternalSourceTypes.AwsEventBridge
  | typeof ExternalSourceTypes.BigCommerce
  | typeof ExternalSourceTypes.Klaviyo
  | typeof ExternalSourceTypes.LoopReturns
  | typeof ExternalSourceTypes.Magento
  | typeof ExternalSourceTypes.Ordergroove
  | typeof ExternalSourceTypes.Qualtrics
  | typeof ExternalSourceTypes.Recharge
  | typeof ExternalSourceTypes.Segment
  | typeof ExternalSourceTypes.Shopify
  | typeof ExternalSourceTypes.Smile
  | typeof ExternalSourceTypes.Yotpo
  | typeof ExternalSourceTypes.Zaius
  | typeof ExternalSourceTypes.Custom;

export type AutoLinkField = typeof AutoLinkFields.Email | typeof AutoLinkFields.Phone;
